// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Home Page Container */
.home-page {
  display: flex;
  flex-direction: column;
  gap: var(--space-2xl);
}

/* Welcome Card */
.welcome-card {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.2) 0%, rgba(118, 75, 162, 0.2) 100%);
  border: 2px solid var(--glass-border-strong);
}

.welcome-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-xl);
  flex-wrap: wrap;
}

.welcome-text {
  flex: 1 1;
  min-width: 300px;
}

.welcome-title {
  font-size: var(--font-size-3xl);
  margin-bottom: var(--space-md);
  color: var(--color-white);
}

.welcome-description {
  font-size: var(--font-size-lg);
  line-height: var(--line-height-relaxed);
  color: var(--text-primary);
  margin: 0;
}

.balance-button {
  min-width: 220px;
}

/* Balance Card */
.balance-card {
  overflow: hidden;
}

.balance-content {
  display: flex;
  flex-direction: column;
  gap: var(--space-lg);
}

.balance-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: var(--space-md);
  border-bottom: 2px solid var(--glass-border);
}

.balance-header h3 {
  font-size: var(--font-size-2xl);
  margin: 0;
}

.balance-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: var(--space-lg);
}

.balance-stat {
  text-align: center;
  padding: var(--space-md);
  background: var(--glass-bg);
  border-radius: var(--radius-lg);
  border: 1px solid var(--glass-border);
}

.stat-label {
  font-size: var(--font-size-sm);
  color: var(--text-muted);
  margin-bottom: var(--space-sm);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stat-value {
  font-size: var(--font-size-3xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-white);
  margin-bottom: var(--space-xs);
}

.stat-spent {
  color: var(--color-error-light);
}

.stat-detail {
  font-size: var(--font-size-xs);
  color: var(--text-faint);
}

.balance-notice {
  padding: var(--space-md);
  background: rgba(255, 152, 0, 0.15);
  border: 1px solid var(--color-warning);
  border-radius: var(--radius-lg);
  color: var(--color-warning-light);
  font-size: var(--font-size-sm);
}

.balance-error {
  padding: var(--space-lg);
  background: rgba(239, 68, 68, 0.15);
  border: 2px solid var(--color-error);
  border-radius: var(--radius-lg);
  color: var(--color-error-light);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  text-align: center;
}

/* Section Title */
.section-title {
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-bold);
  margin-bottom: var(--space-lg);
  text-align: center;
  color: var(--color-white);
}

@keyframes float {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-10px);
  }
}

/* Quick Actions Section */
.quick-actions-section {
  margin-top: var(--space-xl);
}

.quick-actions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: var(--space-md);
}

.action-card {
  cursor: pointer;
}

.action-card .card-body {
  display: flex;
  align-items: center;
  gap: var(--space-lg);
}

.action-icon {
  font-size: 3rem;
  flex-shrink: 0;
}

.action-content {
  flex: 1 1;
}

.action-content h4 {
  font-size: var(--font-size-lg);
  margin-bottom: var(--space-xs);
  color: var(--color-white);
}

.action-content p {
  font-size: var(--font-size-sm);
  color: var(--text-muted);
  margin: 0;
}

/* Announcements Section */
.announcements-section {
  margin-top: var(--space-lg);
}

.announcements-container {
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: var(--space-lg);
  min-height: 350px;
}

.home-page .announcements-list {
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
  max-height: 400px;
  overflow-y: auto;
  padding-right: var(--space-sm);
  scrollbar-width: thin;
  scrollbar-color: var(--glass-border) transparent;
}

.home-page .announcements-list::-webkit-scrollbar {
  width: 6px;
}

.home-page .announcements-list::-webkit-scrollbar-track {
  background: transparent;
}

.home-page .announcements-list::-webkit-scrollbar-thumb {
  background: var(--glass-border);
  border-radius: 3px;
}

.announcement-item {
  padding: var(--space-md);
  background: var(--glass-bg);
  border: 1px solid var(--glass-border);
  border-radius: var(--radius-lg);
  cursor: pointer;
  transition: all var(--transition-base);
  border-left: 3px solid transparent;
}

.announcement-item:hover {
  background: var(--glass-bg);
  border-left-color: var(--category-color, var(--color-primary));
}

.announcement-item.selected {
  background: var(--glass-bg-strong);
  border-left-color: var(--category-color, var(--color-primary));
  border-color: var(--category-color, var(--color-primary));
}

.announcement-item-header {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  margin-bottom: var(--space-xs);
}

.announcement-icon {
  font-size: var(--font-size-lg);
}

.announcement-item-title {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-white);
  margin: 0 0 var(--space-xs) 0;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.announcement-date {
  font-size: var(--font-size-xs);
  color: var(--text-faint);
}

/* Announcement Detail */
.announcement-detail {
  overflow: hidden;
}

.announcement-detail-header {
  display: flex;
  align-items: flex-start;
  gap: var(--space-lg);
  margin-bottom: var(--space-lg);
  padding-bottom: var(--space-lg);
  border-bottom: 1px solid var(--glass-border);
}

.announcement-detail-icons {
  display: flex;
  gap: var(--space-xs);
  flex-shrink: 0;
}

.announcement-detail-icon {
  font-size: 2.5rem;
}

.announcement-detail-title {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-white);
  margin: 0 0 var(--space-xs) 0;
}

.announcement-detail-date {
  font-size: var(--font-size-sm);
  color: var(--text-faint);
}

/* Announcement Sections */
.announcement-section {
  padding: var(--space-lg) 0;
  border-bottom: 1px solid var(--glass-border);
}

.announcement-section:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.announcement-section .section-header {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  margin-bottom: var(--space-md);
}

.announcement-section .section-icon {
  font-size: 1.5rem;
}

.announcement-section .section-title {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--color-white);
  margin: 0;
}

.section-content {
  color: var(--text-primary);
  line-height: var(--line-height-relaxed);
}

.section-content p {
  margin: 0 0 var(--space-sm) 0;
}

.announcement-icons {
  display: flex;
  gap: var(--space-xs);
}

.announcement-featured-images {
  margin-top: var(--space-lg);
  display: flex;
  gap: var(--space-md);
  flex-wrap: wrap;
  /* frames are as tall as their own image, never stretched to the row */
  align-items: flex-start;
}

/* Fixed 200px-wide frame; the height follows the image's own ratio and is capped
   at 250px, so a portrait date keeps its 200x250 crop while a landscape one gets
   a short, wide frame instead of a letterboxed portrait slot. */
.announcement-featured-image {
  border-radius: var(--radius-lg);
  overflow: hidden;
  border: 2px solid var(--glass-border);
  background: rgba(0, 0, 0, 0.3);
  position: relative;
  width: 200px;
  height: auto;
  max-height: 250px;
  flex-shrink: 0;
  /* no inline baseline gap under the image now that the height is fluid */
  line-height: 0;
}

.announcement-featured-image img {
  width: 100%;
  height: auto;
  max-height: 250px;
  object-fit: cover;
  object-position: center;
  transition: transform var(--transition-base);
  display: block;
}

.announcement-featured-image:hover img {
  transform: scale(1.02);
}

.announcement-featured-videos {
  margin-top: var(--space-lg);
  display: flex;
  gap: var(--space-md);
  flex-wrap: wrap;
}

.announcement-featured-video {
  border-radius: var(--radius-lg);
  overflow: hidden;
  border: 2px solid var(--glass-border);
  background: rgba(0, 0, 0, 0.3);
  width: 300px;
  flex-shrink: 0;
}

.announcement-featured-video video {
  width: 100%;
  display: block;
}

/* Responsive */
@media (max-width: 768px) {
  .announcements-container {
    grid-template-columns: 1fr;
  }

  .home-page .announcements-list {
    flex-direction: row;
    overflow-x: auto;
    overflow-y: hidden;
    max-height: none;
    padding-bottom: var(--space-sm);
    padding-right: 0;
  }

  .announcement-item {
    min-width: 200px;
    flex-shrink: 0;
  }
}

/* Fragment Collection Banner */
.collect-fragments-banner {
  background: var(--gradient-primary);
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: slideInDown 0.5s ease-out;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.collect-fragments-content {
  display: flex;
  align-items: center;
  gap: 15px;
}

.collect-fragments-icon {
  font-size: 48px;
  flex-shrink: 0;
  animation: bounce 1s infinite;
}

.collect-fragments-text {
  color: var(--text-primary);
}

.collect-fragments-text strong {
  font-size: 18px;
  display: block;
  margin-bottom: 4px;
}

.collect-fragments-text p {
  margin: 0;
  opacity: 0.9;
  font-size: 14px;
}

.collect-fragments-btn {
  background: var(--glass-bg-strong);
  backdrop-filter: blur(10px);
  border: 1px solid var(--glass-border-strong);
  color: var(--text-primary);
  padding: 12px 24px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 15px;
  white-space: nowrap;
  transition: all 0.3s ease;
}

.collect-fragments-btn:hover:not(:disabled) {
  background: var(--glass-border-strong);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.collect-fragments-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.collect-fragments-message {
  background: rgba(34, 197, 94, 0.15);
  border: 1px solid rgba(34, 197, 94, 0.3);
  border-radius: 12px;
  padding: var(--space-sm) var(--space-md);
  margin-bottom: 24px;
  color: var(--color-success);
  text-align: center;
  font-weight: 500;
}

@media (max-width: 768px) {
  .collect-fragments-banner {
    flex-direction: column;
    text-align: center;
  }

  .collect-fragments-content {
    flex-direction: column;
  }

  .collect-fragments-btn {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/HomePage.css"],"names":[],"mappings":"AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,8FAA8F;EAC9F,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;EACvC,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,2BAA2B;EAC3B,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,sCAAsC;EACtC,+BAA+B;EAC/B,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,oCAAoC;EACpC,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;EAC9B,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA,0BAA0B;AAC1B;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,SAAS;AACX;;AAEA,0BAA0B;AAC1B;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,8DAA8D;AAChE;;AAEA;EACE,kCAAkC;EAClC,8DAA8D;EAC9D,yDAAyD;AAC3D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,yBAAyB;EACzB,6BAA6B;EAC7B,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;EAC9B,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA,0BAA0B;AAC1B;EACE,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,sEAAsE;EACtE,uBAAuB;AACzB;;AAEA;;gEAEgE;AAChE;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,qCAAqC;EACrC,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,wEAAwE;EACxE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;EACvB,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,qCAAqC;EACrC,8BAA8B;EAC9B,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;IAC/B,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA,+BAA+B;AAC/B;EACE,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,4CAA4C;EAC5C,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["@import '../styles/variables.css';\n\n/* Home Page Container */\n.home-page {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2xl);\n}\n\n/* Welcome Card */\n.welcome-card {\n  background: linear-gradient(135deg, rgba(102, 126, 234, 0.2) 0%, rgba(118, 75, 162, 0.2) 100%);\n  border: 2px solid var(--glass-border-strong);\n}\n\n.welcome-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-xl);\n  flex-wrap: wrap;\n}\n\n.welcome-text {\n  flex: 1;\n  min-width: 300px;\n}\n\n.welcome-title {\n  font-size: var(--font-size-3xl);\n  margin-bottom: var(--space-md);\n  color: var(--color-white);\n}\n\n.welcome-description {\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-relaxed);\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.balance-button {\n  min-width: 220px;\n}\n\n/* Balance Card */\n.balance-card {\n  overflow: hidden;\n}\n\n.balance-content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-lg);\n}\n\n.balance-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: var(--space-md);\n  border-bottom: 2px solid var(--glass-border);\n}\n\n.balance-header h3 {\n  font-size: var(--font-size-2xl);\n  margin: 0;\n}\n\n.balance-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: var(--space-lg);\n}\n\n.balance-stat {\n  text-align: center;\n  padding: var(--space-md);\n  background: var(--glass-bg);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--glass-border);\n}\n\n.stat-label {\n  font-size: var(--font-size-sm);\n  color: var(--text-muted);\n  margin-bottom: var(--space-sm);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.stat-value {\n  font-size: var(--font-size-3xl);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-white);\n  margin-bottom: var(--space-xs);\n}\n\n.stat-spent {\n  color: var(--color-error-light);\n}\n\n.stat-detail {\n  font-size: var(--font-size-xs);\n  color: var(--text-faint);\n}\n\n.balance-notice {\n  padding: var(--space-md);\n  background: rgba(255, 152, 0, 0.15);\n  border: 1px solid var(--color-warning);\n  border-radius: var(--radius-lg);\n  color: var(--color-warning-light);\n  font-size: var(--font-size-sm);\n}\n\n.balance-error {\n  padding: var(--space-lg);\n  background: rgba(239, 68, 68, 0.15);\n  border: 2px solid var(--color-error);\n  border-radius: var(--radius-lg);\n  color: var(--color-error-light);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  text-align: center;\n}\n\n/* Section Title */\n.section-title {\n  font-size: var(--font-size-2xl);\n  font-weight: var(--font-weight-bold);\n  margin-bottom: var(--space-lg);\n  text-align: center;\n  color: var(--color-white);\n}\n\n@keyframes float {\n\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n/* Quick Actions Section */\n.quick-actions-section {\n  margin-top: var(--space-xl);\n}\n\n.quick-actions-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: var(--space-md);\n}\n\n.action-card {\n  cursor: pointer;\n}\n\n.action-card .card-body {\n  display: flex;\n  align-items: center;\n  gap: var(--space-lg);\n}\n\n.action-icon {\n  font-size: 3rem;\n  flex-shrink: 0;\n}\n\n.action-content {\n  flex: 1;\n}\n\n.action-content h4 {\n  font-size: var(--font-size-lg);\n  margin-bottom: var(--space-xs);\n  color: var(--color-white);\n}\n\n.action-content p {\n  font-size: var(--font-size-sm);\n  color: var(--text-muted);\n  margin: 0;\n}\n\n/* Announcements Section */\n.announcements-section {\n  margin-top: var(--space-lg);\n}\n\n.announcements-container {\n  display: grid;\n  grid-template-columns: 280px 1fr;\n  gap: var(--space-lg);\n  min-height: 350px;\n}\n\n.home-page .announcements-list {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-sm);\n  max-height: 400px;\n  overflow-y: auto;\n  padding-right: var(--space-sm);\n  scrollbar-width: thin;\n  scrollbar-color: var(--glass-border) transparent;\n}\n\n.home-page .announcements-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.home-page .announcements-list::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.home-page .announcements-list::-webkit-scrollbar-thumb {\n  background: var(--glass-border);\n  border-radius: 3px;\n}\n\n.announcement-item {\n  padding: var(--space-md);\n  background: var(--glass-bg);\n  border: 1px solid var(--glass-border);\n  border-radius: var(--radius-lg);\n  cursor: pointer;\n  transition: all var(--transition-base);\n  border-left: 3px solid transparent;\n}\n\n.announcement-item:hover {\n  background: var(--glass-bg);\n  border-left-color: var(--category-color, var(--color-primary));\n}\n\n.announcement-item.selected {\n  background: var(--glass-bg-strong);\n  border-left-color: var(--category-color, var(--color-primary));\n  border-color: var(--category-color, var(--color-primary));\n}\n\n.announcement-item-header {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n  margin-bottom: var(--space-xs);\n}\n\n.announcement-icon {\n  font-size: var(--font-size-lg);\n}\n\n.announcement-item-title {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-white);\n  margin: 0 0 var(--space-xs) 0;\n  line-height: 1.3;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.announcement-date {\n  font-size: var(--font-size-xs);\n  color: var(--text-faint);\n}\n\n/* Announcement Detail */\n.announcement-detail {\n  overflow: hidden;\n}\n\n.announcement-detail-header {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-lg);\n  margin-bottom: var(--space-lg);\n  padding-bottom: var(--space-lg);\n  border-bottom: 1px solid var(--glass-border);\n}\n\n.announcement-detail-icons {\n  display: flex;\n  gap: var(--space-xs);\n  flex-shrink: 0;\n}\n\n.announcement-detail-icon {\n  font-size: 2.5rem;\n}\n\n.announcement-detail-title {\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-white);\n  margin: 0 0 var(--space-xs) 0;\n}\n\n.announcement-detail-date {\n  font-size: var(--font-size-sm);\n  color: var(--text-faint);\n}\n\n/* Announcement Sections */\n.announcement-section {\n  padding: var(--space-lg) 0;\n  border-bottom: 1px solid var(--glass-border);\n}\n\n.announcement-section:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.announcement-section .section-header {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n  margin-bottom: var(--space-md);\n}\n\n.announcement-section .section-icon {\n  font-size: 1.5rem;\n}\n\n.announcement-section .section-title {\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-white);\n  margin: 0;\n}\n\n.section-content {\n  color: var(--text-primary);\n  line-height: var(--line-height-relaxed);\n}\n\n.section-content p {\n  margin: 0 0 var(--space-sm) 0;\n}\n\n.announcement-icons {\n  display: flex;\n  gap: var(--space-xs);\n}\n\n.announcement-featured-images {\n  margin-top: var(--space-lg);\n  display: flex;\n  gap: var(--space-md);\n  flex-wrap: wrap;\n  /* frames are as tall as their own image, never stretched to the row */\n  align-items: flex-start;\n}\n\n/* Fixed 200px-wide frame; the height follows the image's own ratio and is capped\n   at 250px, so a portrait date keeps its 200x250 crop while a landscape one gets\n   a short, wide frame instead of a letterboxed portrait slot. */\n.announcement-featured-image {\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  border: 2px solid var(--glass-border);\n  background: rgba(0, 0, 0, 0.3);\n  position: relative;\n  width: 200px;\n  height: auto;\n  max-height: 250px;\n  flex-shrink: 0;\n  /* no inline baseline gap under the image now that the height is fluid */\n  line-height: 0;\n}\n\n.announcement-featured-image img {\n  width: 100%;\n  height: auto;\n  max-height: 250px;\n  object-fit: cover;\n  object-position: center;\n  transition: transform var(--transition-base);\n  display: block;\n}\n\n.announcement-featured-image:hover img {\n  transform: scale(1.02);\n}\n\n.announcement-featured-videos {\n  margin-top: var(--space-lg);\n  display: flex;\n  gap: var(--space-md);\n  flex-wrap: wrap;\n}\n\n.announcement-featured-video {\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  border: 2px solid var(--glass-border);\n  background: rgba(0, 0, 0, 0.3);\n  width: 300px;\n  flex-shrink: 0;\n}\n\n.announcement-featured-video video {\n  width: 100%;\n  display: block;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .announcements-container {\n    grid-template-columns: 1fr;\n  }\n\n  .home-page .announcements-list {\n    flex-direction: row;\n    overflow-x: auto;\n    overflow-y: hidden;\n    max-height: none;\n    padding-bottom: var(--space-sm);\n    padding-right: 0;\n  }\n\n  .announcement-item {\n    min-width: 200px;\n    flex-shrink: 0;\n  }\n}\n\n/* Fragment Collection Banner */\n.collect-fragments-banner {\n  background: var(--gradient-primary);\n  padding: 20px;\n  border-radius: 12px;\n  margin-bottom: 24px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  animation: slideInDown 0.5s ease-out;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.collect-fragments-content {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.collect-fragments-icon {\n  font-size: 48px;\n  flex-shrink: 0;\n  animation: bounce 1s infinite;\n}\n\n.collect-fragments-text {\n  color: var(--text-primary);\n}\n\n.collect-fragments-text strong {\n  font-size: 18px;\n  display: block;\n  margin-bottom: 4px;\n}\n\n.collect-fragments-text p {\n  margin: 0;\n  opacity: 0.9;\n  font-size: 14px;\n}\n\n.collect-fragments-btn {\n  background: var(--glass-bg-strong);\n  backdrop-filter: blur(10px);\n  border: 1px solid var(--glass-border-strong);\n  color: var(--text-primary);\n  padding: 12px 24px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 15px;\n  white-space: nowrap;\n  transition: all 0.3s ease;\n}\n\n.collect-fragments-btn:hover:not(:disabled) {\n  background: var(--glass-border-strong);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.collect-fragments-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.collect-fragments-message {\n  background: rgba(34, 197, 94, 0.15);\n  border: 1px solid rgba(34, 197, 94, 0.3);\n  border-radius: 12px;\n  padding: var(--space-sm) var(--space-md);\n  margin-bottom: 24px;\n  color: var(--color-success);\n  text-align: center;\n  font-weight: 500;\n}\n\n@media (max-width: 768px) {\n  .collect-fragments-banner {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .collect-fragments-content {\n    flex-direction: column;\n  }\n\n  .collect-fragments-btn {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
